// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2lvuY","validationTips":"StatementDescriptor_validationTips__2ZCNW"};